// extracted by mini-css-extract-plugin
export default {"List":"Blog_List__OSgxj","h4":"Blog_h4__jO3ye","h5":"Blog_h5__7qMqr"};